import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './doanh-nghiep.reducer';

export const DoanhNghiepDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const doanhNghiepEntity = useAppSelector(state => state.doanhNghiep.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="doanhNghiepDetailsHeading">
          <Translate contentKey="xtdtApp.doanhNghiep.detail.title">DoanhNghiep</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{doanhNghiepEntity.id}</dd>
          <dt>
            <span id="ten">
              <Translate contentKey="xtdtApp.doanhNghiep.ten">Ten</Translate>
            </span>
          </dt>
          <dd>{doanhNghiepEntity.ten}</dd>
          <dt>
            <span id="ma">
              <Translate contentKey="xtdtApp.doanhNghiep.ma">Ma</Translate>
            </span>
          </dt>
          <dd>{doanhNghiepEntity.ma}</dd>
        </dl>
        <Button tag={Link} to="/doanh-nghiep" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/doanh-nghiep/${doanhNghiepEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DoanhNghiepDetail;
